module.exports = __webpack_public_path__ + "static/assets/51e8be843e2f2041731435f81bae1dd4.png";